import axios from 'axios';
import React from 'react'
import { Component } from 'react';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { baseURL } from '../../../../constants/applicationConstants.js';
import { Loader } from '../../../common/loader/loader.jsx';
import RoleFormJsx from './roleManage.jsx'

export default class RoleAddEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryData: null,
            isLoading: false,
            checkedItems: [],
            roleName: '',
            isEditMode: false,
            currentRoleId: null,
        }
    }

    // Handle change for checkboxes
    handleChange = (data) => {
        const { modulePermissionId, moduleId, checked } = data;
        
        // Update the categoryData to reflect the checkbox state
        const updatedCategoryData = this.state.categoryData.map(module => {
            if (module.moduleId === moduleId) {
                return {
                    ...module,
                    modulePermissions: module.modulePermissions.map(permission => {
                        if (permission.modulePermissionId === modulePermissionId) {
                            return {
                                ...permission,
                                hasPermission: checked
                            };
                        }
                        return permission;
                    })
                };
            }
            return module;
        });

        // Update checkedItems array
        let updatedCheckedItems;
        if (checked) {
            // Add to checkedItems if not already present
            const exists = this.state.checkedItems.some(item => 
                item.modulePermissionId === modulePermissionId && item.moduleId === moduleId
            );
            if (!exists) {
                updatedCheckedItems = [
                    ...this.state.checkedItems,
                    { modulePermissionId, moduleId }
                ];
            } else {
                updatedCheckedItems = this.state.checkedItems;
            }
        } else {
            // Remove from checkedItems
            updatedCheckedItems = this.state.checkedItems.filter(item => 
                !(item.modulePermissionId === modulePermissionId && item.moduleId === moduleId)
            );
        }

        this.setState({
            categoryData: updatedCategoryData,
            checkedItems: updatedCheckedItems
        });
    };

    // Handle role name input change
    handleRoleNameChange = (event) => {
        this.setState({ roleName: event.target.value });
    };

    // Handle back to list
    handleBackToList = () => {
        this.props.history.push("/admin/role");
    };

    // Get checked IDs and create/update role
    handleSubmit = () => {
        // Validation: Check if role name is provided
        if (!this.state.roleName.trim()) {
            toast.error('Please enter a role name');
            return;
        }

        // Validation: Check if at least one permission is selected
        if (this.state.checkedItems.length === 0) {
            toast.error('Please select at least one permission');
            return;
        }

        let token = JSON.parse(localStorage.getItem('token'));

        const data = {
            "roleName": this.state.roleName.trim(),
            "access": "write",
            "modules": this.state.checkedItems
        }
        
        this.setState({ isLoading: true });

        // Determine if we're editing or creating
        const apiCall = this.state.isEditMode 
            ? axios.put(`${baseURL}/role/${this.state.currentRoleId}`, data, {
                headers: { 'x-access-token': token }
              })
            : axios.post(`${baseURL}/role`, data, {
                headers: { 'x-access-token': token }
              });

        apiCall.then(res => {
            this.setState({ isLoading: false });
            toast.success(this.state.isEditMode ? 'Role updated successfully!' : 'Role created successfully!');
            // Navigate back to roles list after successful operation
            setTimeout(() => {
                this.props.history.push("/admin/role");
            }, 1000);
        }).catch(err => {
            this.setState({ isLoading: false });
            toast.error(err.response?.data?.error?.message || 
                       (this.state.isEditMode ? 'Failed to update role' : 'Failed to create role'));
        });
    };

    // Initialize form with existing role data for editing
    initializeEditMode = (roleData) => {
        if (roleData) {
            this.setState({
                isEditMode: true,
                currentRoleId: roleData.roleId,
                roleName: roleData.roleName,
                checkedItems: roleData.modules || []
            });
        }
    };

    // Load modules and initialize form
    loadModulesAndInitialize = () => {
        this.setState({ isLoading: true });
        let token = JSON.parse(localStorage.getItem('token'));
        
        axios.get(`${baseURL}/modules`, {
            headers: { 'x-access-token': token }
        }).then(res => {
            const categoryData = res.data.data;
            
            // Check if we're in edit mode
            const editRoleData = this.props.location?.state?.roleData || 
                                JSON.parse(localStorage.getItem('editRoleData') || 'null');
            
            let initialCheckedItems = [];
            
            if (editRoleData) {
                // Edit mode: Set permissions based on existing role data
                this.setState({
                    isEditMode: true,
                    currentRoleId: editRoleData.roleId,
                    roleName: editRoleData.roleName
                });
                
                // Map the existing permissions to the format expected by the form
                initialCheckedItems = editRoleData.modules || [];
                
                // Update categoryData to reflect existing permissions
                categoryData.forEach(module => {
                    module.modulePermissions.forEach(permission => {
                        const hasPermission = initialCheckedItems.some(item => 
                            item.modulePermissionId === permission.modulePermissionId && 
                            item.moduleId === module.moduleId
                        );
                        permission.hasPermission = hasPermission;
                    });
                });
                
                // Clear the stored edit data
                localStorage.removeItem('editRoleData');
            } else {
                // Add mode: Initialize with default permissions
                categoryData.forEach(module => {
                    module.modulePermissions.forEach(permission => {
                        if (permission.hasPermission) {
                            initialCheckedItems.push({
                                modulePermissionId: permission.modulePermissionId,
                                moduleId: module.moduleId
                            });
                        }
                    });
                });
            }

            this.setState({ 
                categoryData: categoryData, 
                checkedItems: initialCheckedItems,
                isLoading: false 
            });
        }).catch(err => {
            this.setState({ isLoading: false });
            toast.error('Failed to load modules');
        });
    };

    componentDidMount = () => {
        this.loadModulesAndInitialize();
    }

    render() {
        return (
            <div>
                <RoleFormJsx
                    categoryData={this.state.categoryData}
                    handleSubmit={this.handleSubmit}
                    handleChange={this.handleChange}
                    roleName={this.state.roleName}
                    handleRoleNameChange={this.handleRoleNameChange}
                    handleBackToList={this.handleBackToList}
                    isEditMode={this.state.isEditMode}
                />
                {this.state.isLoading && <Loader />}
                <ToastContainer />
            </div>
        )
    }
}